<div class="card m-3">
  <div class="card-body">

    <div class="grid-header">
      <h2 class="grid-title">
        <img src="./assets/manufacture.png" width="46px" alt="">
        Projects
      </h2>
      <a routerLink="/projects/add">
        <button mat-raised-button color="primary">
          <mat-icon>add</mat-icon> Add Project
        </button>
      </a>
    </div>

    <div class="search-bar">
      <mat-icon class="search-icon">search</mat-icon>
      <input type="text" [(ngModel)]="searchTerm"
             placeholder="Search projects…"
             class="search-input" />
      <button *ngIf="searchTerm" mat-icon-button class="clear-btn" (click)="searchTerm = ''">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="mat-elevation-z2 table-wrap">

      <!-- Active Projects -->
      <div class="section-header">
        <span class="section-label active-label">
          <mat-icon class="section-icon">build</mat-icon>
          Active Projects
        </span>
        <span class="section-count">{{ activeProjects.length }}</span>
      </div>

      <div class="table-scroll" *ngIf="activeProjects.length > 0; else noActive">
      <table class="table table-striped table-sm project-table">
        <thead>
          <tr>
            <th>Title</th>
            <th *ngIf="!isMobile">Description</th>
            <th *ngIf="!isMobile">Progress</th>
            <th>Price</th>
            <th *ngIf="!isMobile">Priority</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let project of activeProjects">
            <td class="primary-cell">{{ project.title }}</td>
            <td *ngIf="!isMobile" class="desc-cell">{{ project.projectDescription }}</td>
            <td class="progress-cell" *ngIf="!isMobile">
              <div class="progress-wrap">
                <div class="progress-track">
                  <div class="progress-fill" [style.width.%]="getPercent(project) * 100"></div>
                </div>
                <span class="progress-label">{{ getPercent(project) | percent }}</span>
              </div>
            </td>
            <td class="currency-cell">{{ project.totalProjectPrice | currency }}</td>
            <td *ngIf="!isMobile">
              <span class="priority-badge" [ngClass]="'priority-' + project.priority">
                {{ project.priority }}
              </span>
            </td>
            <td class="actions-cell">
              <div class="row-actions">
                <button mat-mini-fab color="primary" class="action-fab"
                        (click)="editProject(project)" matTooltip="Edit project">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-mini-fab color="warn" class="action-fab"
                        (click)="confirmDeleteProject(project)" matTooltip="Delete project">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      <ng-template #noActive>
        <div class="empty-state">
          <mat-icon>build_circle</mat-icon>
          <span>No active projects</span>
        </div>
      </ng-template>

      <!-- Pending Projects -->
      <div class="section-header section-header--pending">
        <span class="section-label pending-label">
          <mat-icon class="section-icon">schedule</mat-icon>
          Pending Projects
        </span>
        <span class="section-count">{{ pendingProjects.length }}</span>
      </div>

      <div class="table-scroll" *ngIf="pendingProjects.length > 0; else noPending">
      <table class="table table-striped table-sm project-table">
        <thead>
          <tr>
            <th>Title</th>
            <th *ngIf="!isMobile">Description</th>
            <th *ngIf="!isMobile">Progress</th>
            <th>Price</th>
            <th *ngIf="!isMobile">Priority</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let project of pendingProjects">
            <td class="primary-cell">{{ project.title }}</td>
            <td *ngIf="!isMobile" class="desc-cell">{{ project.projectDescription }}</td>
            <td class="progress-cell" *ngIf="!isMobile">
              <div class="progress-wrap">
                <div class="progress-track">
                  <div class="progress-fill progress-fill--pending" [style.width.%]="getPercent(project) * 100"></div>
                </div>
                <span class="progress-label">{{ getPercent(project) | percent }}</span>
              </div>
            </td>
            <td class="currency-cell">{{ project.totalProjectPrice | currency }}</td>
            <td *ngIf="!isMobile">
              <span class="priority-badge" [ngClass]="'priority-' + project.priority">
                {{ project.priority }}
              </span>
            </td>
            <td class="actions-cell">
              <div class="row-actions">
                <button mat-mini-fab color="primary" class="action-fab"
                        (click)="editProject(project)" matTooltip="Edit project">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-mini-fab color="warn" class="action-fab"
                        (click)="confirmDeleteProject(project)" matTooltip="Delete project">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      <ng-template #noPending>
        <div class="empty-state empty-state--sm">
          <mat-icon>pending_actions</mat-icon>
          <span>No pending projects</span>
        </div>
      </ng-template>

      <!-- Completed Projects -->
      <div class="section-header section-header--completed">
        <span class="section-label completed-label">
          <mat-icon class="section-icon">check_circle</mat-icon>
          Completed Projects
        </span>
        <span class="section-count">{{ completedProjects.length }}</span>
      </div>

      <div class="table-scroll" *ngIf="completedProjects.length > 0; else noCompleted">
      <table class="table table-striped table-sm project-table">
        <thead>
          <tr>
            <th>Title</th>
            <th *ngIf="!isMobile">Description</th>
            <th *ngIf="!isMobile">Progress</th>
            <th>Price</th>
            <th *ngIf="!isMobile">Priority</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let project of completedProjects">
            <td class="primary-cell">{{ project.title }}</td>
            <td *ngIf="!isMobile" class="desc-cell">{{ project.projectDescription }}</td>
            <td class="progress-cell" *ngIf="!isMobile">
              <div class="progress-wrap">
                <div class="progress-track progress-track--complete">
                  <div class="progress-fill progress-fill--complete" style="width: 100%"></div>
                </div>
                <span class="progress-label">{{ getPercent(project) | percent }}</span>
              </div>
            </td>
            <td class="currency-cell">{{ project.totalProjectPrice | currency }}</td>
            <td *ngIf="!isMobile">
              <span class="priority-badge" [ngClass]="'priority-' + project.priority">
                {{ project.priority }}
              </span>
            </td>
            <td class="actions-cell">
              <div class="row-actions">
                <button mat-mini-fab color="primary" class="action-fab"
                        (click)="editProject(project)" matTooltip="Edit project">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      <ng-template #noCompleted>
        <div class="empty-state empty-state--sm">
          <mat-icon>check_circle_outline</mat-icon>
          <span>No completed projects</span>
        </div>
      </ng-template>

    </div>

    <div class="record-count" *ngIf="filteredProjects.length > 0">
      {{ filteredProjects.length }} project{{ filteredProjects.length !== 1 ? 's' : '' }}
    </div>

  </div>
</div>
